import Vue from 'vue'

import esbBreadcrumb from './breadcrumb/View'

Vue.component('esb-breadcrumb', esbBreadcrumb);
